import { Divider } from "@components"
import PropTypes from "prop-types"

const SimpleCheckListItem = ({ 
  button, 
  description, 
  icon, 
  showDivider = true, 
  title 
}) => (
  <div>
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-2">
        {icon}
        
        <div>
          <p className="font-semibold text-gray-300 dark:foreground">{title}</p>
          <p className="text-sm text-gray-200 dark:text-content2-foreground">{description}</p>
        </div>
      </div>

      {button && button}
    </div>

    {showDivider && <Divider className="my-3" />}
  </div>
)

SimpleCheckListItem.propTypes = {
  button: PropTypes.node,
  description: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  showDivider: PropTypes.bool,
  title: PropTypes.string.isRequired
}

export default SimpleCheckListItem